import { of } from 'rxjs'
import { switchMap, take } from 'rxjs/operators'

import { AuditCampaign, getTranslatedString } from '@skinsoft/types'
import { auditCampaignSelectors, thesaurusTermSelectors } from '@skinsoft/selectors'
import { OfflineDataFetcher } from '../offline-data-fetcher'
import { CACHE_KEYS } from '../search-type-cache-key-mapping'
import { ThesaurusTermOfflineDataFetcher } from './thesaurus-term-offline-data-fetcher'
import { matchesRegex } from '@skinsoft/utils'

export class AuditCampaignOfflineDataFetcher extends OfflineDataFetcher<AuditCampaign>{
    constructor(cacheKey: string) {
        super(cacheKey);
    }

    protected async queryTextFilter(entity: AuditCampaign, queryText: string, locale: string): Promise<boolean> {
        const lowerCaseQueryText: string = queryText.toLowerCase()

        // campaign title
        const title: string = auditCampaignSelectors.title(entity, locale);
        const titleMatch = title ? matchesRegex(lowerCaseQueryText, title) : false;

        // campaign number
        const refNumber: string = auditCampaignSelectors.identificationNumber(entity);
        const refNumberMatch = refNumber ? matchesRegex(lowerCaseQueryText, refNumber) : false;

        // campaign number
        const campaignTypeId: string = auditCampaignSelectors.auditType(entity);
        const campaignType: string = await new ThesaurusTermOfflineDataFetcher(CACHE_KEYS.ThesaurusTerm).fetchOneFromId(campaignTypeId)
            .pipe(
                take(1),
                switchMap(
                    term => {
                        return of(getTranslatedString(thesaurusTermSelectors.preferredTerm(term), locale))
                    }
                )
            ).toPromise()
        const campaignTypeMatch = campaignType ? matchesRegex(lowerCaseQueryText, campaignType) : false;

        return titleMatch || refNumberMatch || campaignTypeMatch;
    }


}